module.exports = __webpack_public_path__ + "static/media/drafting-compass.ca07d6b7.svg";